import React from 'react';
import { ServicesContext } from '~/services';

interface StaticInfoProps {
    edit: () => void;
}
export function StaticInfo({ edit }: StaticInfoProps) {
    const servicesContext = React.useContext(ServicesContext);
    const user = servicesContext.user.get();

    return (
        <>
            <div className="row">
                <div className="col-3 text-end">Primary Email</div>
                <div className="col-9">{user.email}</div>
            </div>
            <div className="row align-items-center">
                <div className="col-3 text-end">Password</div>
                <div className="col-5">*****</div>
                <div className="col-4 text-end">
                    <button className="btn btn-primary" onClick={edit} type="button">
                        Change Password
                    </button>
                </div>
            </div>
        </>
    );
}
